import { render } from "./AdminRateEdit.vue?vue&type=template&id=5a522eb4&scoped=true&ts=true&lang=true"
import script from "./AdminRateEdit.vue?vue&type=script&lang=ts"
export * from "./AdminRateEdit.vue?vue&type=script&lang=ts"

import "./AdminRateEdit.vue?vue&type=style&index=0&id=5a522eb4&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a522eb4"]])

export default __exports__